import { render } from "./OfferIPA.vue?vue&type=template&id=2abf2cfe&scoped=true"
import script from "./OfferIPA.vue?vue&type=script&lang=js"
export * from "./OfferIPA.vue?vue&type=script&lang=js"

import "./OfferIPA.vue?vue&type=style&index=0&id=2abf2cfe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2abf2cfe"]])

export default __exports__